import { Component, HostBinding, OnDestroy, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { LogCategory, LoggerService, LogType, LogWidget } from '../../core/services/logger.service';
import { SolarWindsService } from '../../services/solar-winds.service';
import { ProfileService } from '../../core/services/profile.service'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IWidgetComponent } from '../../shared/widget/i-widget-component';
import { Widget } from '../../shared/widget/widget';
import { Observable, Subject, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { LoadingWrapper } from '../../shared/loadingwrapper'

@Component({
    selector: 'my-equipment',
    templateUrl: './my-equipment.component.html',
    styleUrls: ['./my-equipment.component.scss'],
    standalone: false
})
export class MyEquipmentComponent implements OnInit, OnDestroy, AfterViewInit, IWidgetComponent {
    public myEquipment: LoadingWrapper<any>;
    public data: Widget;

    @HostBinding('class')
    get size(): string {
        var widgetSize = 'col-md-' + this.data.Size.toString();

        switch (this.data.Size) {
            case 4: {
                widgetSize += ' widget-small';
                break;
            }
            case 6: {
                widgetSize += ' widget-medium';
                break;
            }
            case 12: {
                widgetSize += ' widget-large';
                break;
            }
        }

        return widgetSize;
    }

    constructor(
        private logger: LoggerService,
        public solarWindsService: SolarWindsService,
        private modalService: NgbModal,
        private profileService: ProfileService,
        private changeDetector: ChangeDetectorRef
    ) {
        this.log("constructor", null, LogCategory.Constructor);
    }
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Widget, LogWidget.MySupportRequests, category);
    }

    ngOnInit() {
        this.log("ngOnInit", null, LogCategory.Init);
        this.myEquipment = new LoadingWrapper(this.solarWindsService.equipment$);
    }

    ngOnDestroy() {
        this.log("ngOnDestroy", "", LogCategory.Destroy);
    }

    ngAfterViewInit() {
        // See https://blog.angularindepth.com/everything-you-need-to-know-about-the-expressionchangedafterithasbeencheckederror-error-e3fd9ce7dbb4
        // Added after error handling template added to component.
        this.changeDetector.detectChanges();
    }
}

